import { useQuery } from "react-query";
import { gql } from "graphql-request";
import { usePbm2Url } from "@common/hooks/usePbm2Url";
import { IStates } from "../contracts";

export function useStates() {
  const { request } = usePbm2Url();

  return useQuery("refund_states", async () => {
    const { Refund_findStates } = await request(
      gql`
      query findStates {
        Refund_findStates {
            stateId,
            name,
            code
        }
      }`
    );
    return Refund_findStates as IStates | undefined;
  });
}

